import React from 'react'

const upload = ({ className, fill }) => {
  return (
    <><svg className={className} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 5L10.5 2.5M10.5 2.5L13 5M10.5 2.5L10.5 12.5" stroke={fill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.75 7.5L6.33333 7.5C4.49238 7.5 3 8.99238 3 10.8333L3 14.1667C3 16.0076 4.49238 17.5 6.33333 17.5L14.6667 17.5C16.5076 17.5 18 16.0076 18 14.1667L18 10.8333C18 8.99238 16.5076 7.5 14.6667 7.5L14.25 7.5" stroke={fill} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    </>
  )
}

export default upload